<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <CalculatorHeader>
        <h2>Equity Release Mortgage Calculator</h2>.
        <h5>NO CREDIT CHECKS!</h5>
        <p>Are you aged over 55 and wondering how much equity release can I get? Use our lifetime mortgage equity
          release calculator to work out how much you might be able to borrow.<br><br>All we require is the estimated
          value of your property, any amount outstanding against it (including any secured loans), the number of
          applicants, and the age of the youngest homeowner.</p>
      </CalculatorHeader>
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="calculator-container">

            <div @keyup="resetCalculation" @change="resetCalculation">
              <InputElement
                  fieldText="Estimated Property Value"
              >
                <InputTypeNumber currencyPlaceholder placeholder="e.g. 230000" v-model="propertyValue"/>
              </InputElement>

              <transition name="fade-x" mode="out-in">
                <InputElement
                    v-if="propertyValue > 0"
                    fieldText="Outstanding Mortgage"
                >
                  <InputTypeNumber currencyPlaceholder placeholder="e.g. 30000" v-model="outstanding"/>
                </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                <BooleanChoiceButtons
                    v-if="propertyValue > 0 && outstanding !== null && outstanding !== undefined && outstanding !== '' && outstanding >= 0"
                    fieldText="Number of Applicants"
                    buttonTextLeft="1"
                    buttonTextRight="2"
                >
                  <template v-slot:left>
                    <input type="radio" v-model="applicantsQty" value="1">
                  </template>
                  <template v-slot:right>
                    <input type="radio" v-model="applicantsQty" value="2">
                  </template>
                </BooleanChoiceButtons>
              </transition>

              <transition name="fade-x" mode="out-in">
                <InputElement
                    v-if="propertyValue > 0 && outstanding !== null && outstanding !== undefined && outstanding !== '' && outstanding >= 0 && applicantsQty > 0"
                    fieldText="Age of Youngest Homeowner"
                    class="pt-4"
                >
                  <VueSlider
                      ref="slider"
                      v-model="age"
                      v-bind="sliderOptions"
                      class="mt-4 mt-md-0"
                      @keyup="resetCalculation" @change="resetCalculation"
                  >
                    <template #tooltip>
                      <div style="min-width: 6rem; font-size: small;" v-if="age === null ">Set your age</div>
                      <div v-if="age >= 55 && age <= 89">{{ age }}</div>
                      <div v-if="age > 89">90+</div>
                    </template>
                  </VueSlider>
                </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                <div class="row mt-5 mb-5" v-if="propertyValue > 0 && outstanding !== null && outstanding !== undefined && outstanding !== '' && outstanding >= 0 && applicantsQty > 0 && age">
                  <div class="col-md-6 col-lg-4 fw-bold">When will you be ready to move forward?</div>
                  <div class="col-md-6 col-lg-8 fcs-grid-long">
                    <DropdownMenu :dropdownOptions="dropdownOptionsMove" v-model="calcReason2"></DropdownMenu>
                  </div>
                </div>
              </transition>

              <!-- <transition name="fade-x" mode="out-in">
                <InputElement
                    v-if="propertyValue > 0 && outstanding !== null && outstanding !== undefined && outstanding !== '' && outstanding >= 0 && applicantsQty > 0 && age"
                    fieldText="Name"
                >
                  <input class="form-control calc-form-control" type="text" v-model="listName">
                </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                  <InputElement
                      v-if="propertyValue > 0 && outstanding !== null && outstanding !== undefined && outstanding !== '' && outstanding >= 0 && applicantsQty > 0 && age"
                      fieldText="Email Address"
                  >
                      <input class="form-control calc-form-control" type="email" v-model="emailAddress">
                  </InputElement>
              </transition>

              <transition name="fade-x" mode="out-in">
                <div class="row align-items-center" v-if="propertyValue > 0 && outstanding !== null && outstanding !== undefined && outstanding !== '' && outstanding >= 0 && applicantsQty > 0 && age">
                    <div class="col-md-1">
                        <input type="checkbox" id="privacy" v-model="consent" >
                    </div>
                    <div class="col-md-11">
                        <label for="privacy">I consent to my personal information being processed in accordance with Just Mortgage Brokers <a href="/privacy-policy/" target="_blank">Privacy Policy</a></label>
                    </div>
                </div>
              </transition> -->

              <transition name="scale-in" mode="out-in">
                <div
                    v-if="propertyValue > 0 && outstanding !== null && outstanding !== undefined && outstanding !== '' && outstanding >= 0 && applicantsQty > 0 && age"
                    class="text-center mt-5 mb-3"
                >
                  <div class="btn btn-secondary" @click="calculate">CALCULATE</div>
                </div>
              </transition>
            </div>

            <transition name="fade-y" mode="out-in">
              <div
                  class="mt-5"
                  v-if="calcCompleted"
                  ref="resultsContainer"
              >

                <div class="row mb-3">
                  <div class="col-12 col-md-6 mb-2 mb-md-0">
                    <ResultsContainer class="full-height">
                      <ul class="text-smaller">
                        <li>Draw a tax-free lump sum and spend it as you please</li>
                        <li>Retain ownership of your property at all times</li>
                        <li>We're Members of the Equity Release Council</li>
                        <li>Protect your beneficiaries</li>
                      </ul>
                      <b class="text-uppercase">The figures are an indication of the amount available, subject to full
                        assessment and underwriting. Please refer to one of our specialist advisers.</b>
                    </ResultsContainer>
                  </div>
                  <div class="col-12 col-md-6 mb-2 mb-md-0">
                    <ResultsContainer class="full-height">
                      <div class="mb-3">Thank you for your details. Please see below for the maximum amounts you can
                        release based on the information you have provided
                      </div>
                      <h4>Lifetime Mortgage:</h4>
                      <span class="fcs-price">£{{ formatNumberOutput(lifetimeMortgage) }}</span>
                      <h4>Enhanced Lifetime Mortgage *:</h4>
                      <span class="fcs-price">£{{ formatNumberOutput(enhancedLifetimeMortgage) }}</span>
                      <div class="text-smaller">* If you are in poor health you may be entitled to better terms with an
                        Enhanced Lifetime Mortgage.
                      </div>
                    </ResultsContainer>
                  </div>
                </div>

                <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

              </div>
            </transition>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import CalculatorHeader from '@/components/utilities/calculatorHeader.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import ReturnedValueBox from '@/components/utilities/returnedValueBox.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  components: {
    BooleanChoiceButtons,
    CalculatorHeader,
    DropdownMenu,
    InputElement,
    InputTypeNumber,
    MultiplyChoiceButton,
    ResultsContainer,
    ReturnedValueBox,
    SubmissionForm,
    VueSlider
  },
  data() {
    return {
      calculatorName: 'equity-release-calculator',
      calcCompleted: false,
      lifetimeMortgaget: null,
      enhancedLifetimeMortgage: null,
      homeReversion: 0,
      propertyValue: null,
      outstanding: null,
      applicantsQty: 0,
      age: null,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      dropdownOptionsMove: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "12+ months", text: "12+ months"},
        {value: "6-12 months", text: "6-12 months"},
        {value: "In the next 3 months", text: "In the next 3 months"},
        {value: "As soon as possible", text: "As soon as possible"},
      ],
      calculation:
          {
            "55": {
              "standard": 25.5,
              "enhanced": 39.1,
              "interest": 21
            },
            "56": {
              "standard": 26.5,
              "enhanced": 40.2,
              "interest": 22
            },
            "57": {
              "standard": 27.5,
              "enhanced": 41.3,
              "interest": 23
            },
            "58": {
              "standard": 28.5,
              "enhanced": 42.4,
              "interest": 24
            },
            "59": {
              "standard": 29.5,
              "enhanced": 43.5,
              "interest": 25
            },
            "60": {
              "standard": 32,
              "enhanced": 44.6,
              "interest": 29
            },
            "61": {
              "standard": 33,
              "enhanced": 45.7,
              "interest": 30
            },
            "62": {
              "standard": 34,
              "enhanced": 47.3,
              "interest": 31
            },
            "63": {
              "standard": 35,
              "enhanced": 48.4,
              "interest": 32
            },
            "64": {
              "standard": 36,
              "enhanced": 49.5,
              "interest": 33
            },
            "65": {
              "standard": 37,
              "enhanced": 50.6,
              "interest": 34
            },
            "66": {
              "standard": 38,
              "enhanced": 51,
              "interest": 35
            },
            "67": {
              "standard": 39,
              "enhanced": 51.8,
              "interest": 36
            },
            "68": {
              "standard": 40,
              "enhanced": 52.9,
              "interest": 37
            },
            "69": {
              "standard": 41,
              "enhanced": 54,
              "interest": 38
            },
            "70": {
              "standard": 42,
              "enhanced": 54.5,
              "interest": 39
            },
            "71": {
              "standard": 43.2,
              "enhanced": 55.5,
              "interest": 40
            },
            "72": {
              "standard": 44.4,
              "enhanced": 55.5,
              "interest": 41
            },
            "73": {
              "standard": 45.6,
              "enhanced": 55.5,
              "interest": 42
            },
            "74": {
              "standard": 46.8,
              "enhanced": 55.5,
              "interest": 43
            },
            "75": {
              "standard": 48,
              "enhanced": 55.5,
              "interest": 44
            },
            "76": {
              "standard": 49.2,
              "enhanced": 55.5,
              "interest": 45
            },
            "77": {
              "standard": 50.4,
              "enhanced": 55.5,
              "interest": 46
            },
            "78": {
              "standard": 51,
              "enhanced": 55.5,
              "interest": 47
            },
            "79": {
              "standard": 51.5,
              "enhanced": 55.5,
              "interest": 48
            },
            "80": {
              "standard": 52,
              "enhanced": 55.5,
              "interest": 49
            },
            "81": {
              "standard": 52.5,
              "enhanced": 55.5,
              "interest": 49
            },
            "82": {
              "standard": 53,
              "enhanced": 55.5,
              "interest": 49
            },
            "83": {
              "standard": 53.5,
              "enhanced": 55.5,
              "interest": 49
            },
            "84": {
              "standard": 54,
              "enhanced": 55.5,
              "interest": 49
            },
            "85": {
              "standard": 54,
              "enhanced": 55.5,
              "interest": 49
            },
            "86": {
              "standard": 54,
              "enhanced": 55.5,
              "interest": 49
            },
            "87": {
              "standard": 54,
              "enhanced": 55.5,
              "interest": 49
            },
            "88": {
              "standard": 54,
              "enhanced": 55.5,
              "interest": 49
            },
            "89": {
              "standard": 54,
              "enhanced": 55.5,
              "interest": 49
            },
            "90": {
              "standard": 54,
              "enhanced": 55.5,
              "interest": 49
            }
          },
      sliderOptions: {
        min: 55,
        max: 90,
      },
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 3, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 4 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      let match = this.calculation[this.age];

      this.lifetimeMortgage = this.propertyValue * (match.standard / 100);
      this.enhancedLifetimeMortgage = this.propertyValue * (match.enhanced / 100);
      // this.homeReversion = this.propertyValue * (match.interest / 100);
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults =
          `
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
        const resultsContainer = this.$refs.resultsContainer;

        if (resultsContainer) {
          // Get the bounding rectangle of the element
          const rect = resultsContainer.getBoundingClientRect();

          // Calculate the target scroll position
          const targetScrollPosition = window.scrollY + rect.top - 200;

          // Scroll to the target position
          window.scrollTo({
            top: targetScrollPosition,
            behavior: 'smooth'
          });
        } else {
          console.error('resultsContainer is undefined');
        }
      });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if (newNumber === 'NaN') {
        return 0
      }
      return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function (_, prep, letter) {
        return (prep && ' ') + letter.toUpperCase();
      });
    },
    resetCalculation() {
      this.calcCompleted = false;
    }
  },
  computed: {
    collateMessageBody() {
      const calculatorData =
          {
            calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
            calculatorResults:
                `
                    Estimated Property Value: £${this.propertyValue}
                    Outstanding Mortgage: £${this.outstanding}
                    Applicants: ${this.applicantsQty}
                    Age of Youngest Homeowner: ${this.age}
                    Lifetime Mortgage: £${this.lifetimeMortgage}
                    Enhanced Lifetime Mortgage: £${this.enhancedLifetimeMortgage}
                `
          }
      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
@import './styles/slider.scss';
</style>